export default __webpack_public_path__ + "static/best-opticians-perth-logo-98a8ef2603dcdecb6206eaa546e00094.png";